// extracted by css-extract-rspack-plugin
export default {"cls1":"ScrollableTabNav-wjs-cls1_xyz","cls2":"ScrollableTabNav-wjs-cls2_AZb ScrollableTabNav-wjs-cls1_xyz"};